// Angular
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// External Modules
import ObjectID from 'bson-objectid';

export function ValidObjectID(required: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === undefined || control.value === null || control.value === '') {
      if (required) {
        return { required: true };
      } else {
        return null;
      }
    }
    if (!ObjectID.isValid(control.value)) {
      return { objectID: true };
    }
    return null;
  };
}
